"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTextToHighlight = void 0;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _tokenMatcher = require("../../lib/utils/helper/tokenMatcher");

var getSpanText = function getSpanText(data) {
  if (typeof data !== 'object' || !data) return '';
  if (data.plainRow !== undefined) return data.plainRow.toLowerCase();
  return data.text.toLowerCase();
};

var getPossibleMatches = function getPossibleMatches(searchData, searchText) {
  var searchTextTokens = (0, _tokenMatcher.tokenize)(searchText);
  if (!searchTextTokens.length) return [];
  var results = [];

  for (var _i = 0, _Object$entries = Object.entries(searchData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
        groupData = _Object$entries$_i[1];

    var _iterator = (0, _createForOfIteratorHelper2.default)(groupData.entries()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _step$value = (0, _slicedToArray2.default)(_step.value, 2),
            data = _step$value[1];

        var spanText = getSpanText(data);
        var spanTextTokens = (0, _tokenMatcher.tokenize)(spanText);
        if (!spanTextTokens.length) continue;
        var longestSequence = (0, _tokenMatcher.findLongestCommonTokenSequence)(spanTextTokens, searchTextTokens);
        if (!longestSequence.length) continue;
        var minLength = Math.min(spanTextTokens.length, searchTextTokens.length);
        var lengthRation = Math.max(spanTextTokens.length, searchTextTokens.length) / minLength; // Penalty for matches with very different length, as they are less likely to be relevant
        // Picked coefficients from https://github.com/nol13/fuzzball.js/blob/f53f956ce04dfdfdb469c69ed988d2009586b9cf/fuzzball.js#L342

        var lengthScale = lengthRation > 8 ? .6 : 1;
        var score = longestSequence.length / minLength * lengthScale * 100;
        results.push({
          score: score,
          data: data
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return results.sort(function (a, b) {
    return b.score - a.score;
  });
}; // MAIN


var getTextToHighlight = function getTextToHighlight(searchData, searchText) {
  try {
    var possibleMatches = getPossibleMatches(searchData, searchText);
    if (!possibleMatches.length) return [];
    var rowIds = [possibleMatches[0].data.rowId];

    for (var i = 1; i < possibleMatches.length; i++) {
      var match = possibleMatches[i];

      if (match.score === possibleMatches[0].score) {
        rowIds.push(match.data.rowId);
      } else {
        break;
      }
    }

    return rowIds;
  } catch (error) {
    console.error('[getTextToHighlight] error: ', error);
    return [];
  }
};

exports.getTextToHighlight = getTextToHighlight;